export const MODELS_WITH_PAYMENT = ['fixed', 'subscription'] as const;
